import { ICommonSettings } from "@kuika/kuika-cl-model";
import { PureComponent, ReactNode } from "react";
import { ICommonConfigDeleteFunctionParams, ICommonConfigSaveFunctionParams } from "../app-settings-config-container";
import { ConfigSettingSelect } from "../config-setting-select";
import {
  ConfigIpRateLimitingSettings,
  IP_RATE_LIMITING_SETTINGS_SEARCH_TERMS
} from "./app-settings-config-ip-rate-limiting";

const DEFAULT_RATE_LIMIT_ID = "default";

export interface IConfigIpRateLimitingInputState {
  showModal: boolean;
  editingId: string;
}

export interface IConfigIpRateLimitingInputProps {
  parentConfigValue?: string | null;
  commonSettings: ICommonSettings;
  getSectionDescription: (contentKey: string) => ReactNode;
  handleUpdateCustomFormInput: (formItemName: string[], value: string | null) => void;
  handleCreateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleUpdateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleDeleteCommonConfig: (params: ICommonConfigDeleteFunctionParams) => void;
}

export class ConfigIpRateLimitingInput extends PureComponent<
  IConfigIpRateLimitingInputProps,
  IConfigIpRateLimitingInputState
> {
  formInputName = ["apiConfig", "ipRateLimitingSettingsId"];

  constructor(props: IConfigIpRateLimitingInputProps) {
    super(props);
    this.state = { showModal: false, editingId: "" };
  }

  openModal = () => this.setState({ showModal: true, editingId: "" });

  closeModal = () => this.setState({ showModal: false });

  setEditing = (id: string) => {
    if (!id || id === DEFAULT_RATE_LIMIT_ID) return;
    this.setState({ editingId: id, showModal: true });
  };

  handleRestore = (): void => {
    this.props.handleUpdateCustomFormInput?.(this.formInputName, this.props.parentConfigValue ?? null);
  };

  render() {
    const {
      parentConfigValue,
      commonSettings,
      getSectionDescription,
      handleUpdateCustomFormInput,
      handleCreateCommonConfig,
      handleUpdateCommonConfig,
      handleDeleteCommonConfig
    } = this.props;

    type RateLimitOption = { id: string; name: string; isBuiltIn?: boolean };

    const options: RateLimitOption[] = [
      { id: DEFAULT_RATE_LIMIT_ID, name: "Default", isBuiltIn: true },
      ...((commonSettings.ipRateLimitingSettings || []).map((x) => ({ id: x.id, name: x.name })) as RateLimitOption[])
    ];

    return (
      <>
        <ConfigIpRateLimitingSettings
          formInputName={this.formInputName}
          showModal={this.state.showModal}
          closeModal={this.closeModal}
          editingIpRateLimitingId={this.state.editingId}
          commonSettings={commonSettings}
          getSectionDescription={getSectionDescription}
          handleCreateCommonConfig={handleCreateCommonConfig}
          handleUpdateCommonConfig={handleUpdateCommonConfig}
          handleDeleteCommonConfig={handleDeleteCommonConfig}
        />
        <ConfigSettingSelect
          searchTerms={IP_RATE_LIMITING_SETTINGS_SEARCH_TERMS}
          label="Rate Limiting"
          formInputName={this.formInputName}
          options={options}
          getValueProps={(value: string | null) => ({ value: value == null ? DEFAULT_RATE_LIMIT_ID : value })}
          normalize={(val: string | null) =>
            val === DEFAULT_RATE_LIMIT_ID || val === "null" || val === "" ? null : val
          }
          tooltipContentKey="appsettings_ipratelimiting"
          onAddNew={this.openModal}
          onEdit={this.setEditing}
          parentConfigValue={this.props.parentConfigValue}
          onRestore={this.handleRestore}
          dropdownTestId="appSettingsIpRateLimitingDropdown"
          addNewTestId="appSettingsIpRateLimitingDropdownAddNew"
          editTestId="appSettingsIpRateLimitingEditButton"
        />
      </>
    );
  }
}
